import QuizOption from "../components/shared/QuizOption";

// Quiz options data for all steps
export const QUIZ_OPTIONS_DATA = {
  // Step 0 - Welcome (Gender identification)
  welcome: [
    {
      value: "woman",
      text: "WOMAN",
      iconType: "woman",
      hasIcon: true,
    },
    {
      value: "man",
      text: "MAN",
      iconType: "man",
      hasIcon: true,
    },
    {
      value: "other",
      text: "NON-BINARY",
      iconType: "nonBinary",
      hasIcon: true,
    },
  ],

  // Step 1 - Age
  age: [
    { value: "18-24", text: "18-24" },
    { value: "25-35", text: "25-34" },
    { value: "35-44", text: "35-44" },
    { value: "45+", text: "45+" },
  ],

  // Step 3 - Use AI (with images)
  useAI: [
    {
      value: "1",
      text: "I use ChatGPT to help with simple tasks",
      image: "/assets/1.webp",
      alt: "ChatGPT user",
      hasIcon: true,
    },
    {
      value: "2",
      text: "I actively explore AI including image and video generation",
      image: "/assets/2.webp",
      alt: "AI explorer",
      hasIcon: true,
    },
    {
      value: "3",
      text: "I experiment with AI tools, can write prompts and use it for coding",
      image: "/assets/3.webp",
      alt: "AI experimenter",
      hasIcon: true,
      defaultChecked: true,
    },
    {
      value: "4",
      text: "I have no experience with AI",
      image: "/assets/4.webp",
      alt: "AI beginner",
      hasIcon: true,
    },
  ],

  // Step 4 - Friend AI
  friendAI: [
    { value: "1", text: "Having fun" },
    { value: "2", text: "Staying motivated and focused" },
    { value: "3", text: "Learning new skills" },
    { value: "4", text: "Emotional support and advice" },
    { value: "5", text: "Creative ideas and brainstorming" },
  ],

  // Step 6 - Feel
  feel: [
    { value: "1", text: "Understanding" },
    { value: "2", text: "Interesting conversations" },
    { value: "3", text: "Shared interests" },
    { value: "4", text: "Support" },
    { value: "5", text: "Reliability" },
  ],

  // Step 7 - Frustration
  frustration: [
    { value: "1", text: "Judgement" },
    { value: "2", text: "Inconsistency" },
    { value: "3", text: "Distance" },
    { value: "4", text: "Shallowness" },
  ],

  // Step 8 - Quality (with images)
  quality: [
    {
      value: "1",
      text: "Kindness",
      image: "/assets/5.webp",
      alt: "Kindness",
      hasIcon: true,
    },
    {
      value: "2",
      text: "Sense of humor",
      image: "/assets/6.webp",
      alt: "Sense of humor",
      hasIcon: true,
    },
    {
      value: "3",
      text: "Intelligence",
      image: "/assets/7.webp",
      alt: "Intelligence",
      hasIcon: true,
    },
    {
      value: "4",
      text: "Confidence",
      image: "/assets/8.webp",
      alt: "Confidence",
      hasIcon: true,
    },
    {
      value: "5",
      text: "Playfulness",
      image: "/assets/9.webp",
      alt: "Playfulness",
      hasIcon: true,
    },
  ],

  // Step 9 - Treat
  treat: [
    { value: "1", text: "Like a friend" },
    { value: "2", text: "Dismissively or coldly" },
    { value: "3", text: "Flirtatiously" },
    { value: "4", text: "With kindness and respect" },
  ],

  // Step 10 - Communication
  communication: [
    { value: "1", text: "Mostly at work" },
    { value: "2", text: "I have a few close friends" },
    { value: "3", text: "I rarely talk to anyone" },
    { value: "4", text: "I prefer being on my own" },
  ],

  // Step 12 - Gender
  gender: [
    { value: "woman", text: "Woman" },
    { value: "man", text: "Man" },
    { value: "other", text: "Non-binary" },
  ],

  // Step 13 - Type of Look (with images)
  typeOfLook: [
    {
      value: "1",
      text: "Girl next door",
      image: "/assets/10.webp",
      alt: "Girl next door",
      hasIcon: true,
    },
    {
      value: "2",
      text: "Femme fatale",
      image: "/assets/11.webp",
      alt: "Femme fatale",
      hasIcon: true,
    },
    {
      value: "3",
      text: "Manic pixie girl",
      image: "/assets/12.webp",
      alt: "Manic pixie girl",
      hasIcon: true,
    },
    {
      value: "4",
      text: "Goth girl",
      image: "/assets/13.webp",
      alt: "Goth girl",
      hasIcon: true,
    },
    {
      value: "5",
      text: "Anime otaku",
      image: "/assets/14.webp",
      alt: "CAnime otaku",
      hasIcon: true,
    },
    {
      value: "6",
      text: "Nerdy girl",
      image: "/assets/15.webp",
      alt: "Nerdy girl",
      hasIcon: true,
    },
  ],
};

// Helper function to get options for a specific step
export const getQuizOptions = (stepName) => {
  return QUIZ_OPTIONS_DATA[stepName] || [];
};

// Helper function to render quiz options
export const renderQuizOptions = (stepName, onAnswer, name) => {
  const options = getQuizOptions(stepName);

  return options.map((option) => (
    <QuizOption
      key={option.value}
      value={option.value}
      name={name}
      onClick={(value) => onAnswer(stepName, value)}
      hasIcon={option.hasIcon}
      defaultChecked={option.defaultChecked}
    >
      {option.hasIcon && (
        <picture>
          <img src={option.image} className="option-icon" alt={option.alt} />
        </picture>
      )}
      <div>
        <p>
          <strong>{option.text}</strong>
        </p>
      </div>
    </QuizOption>
  ));
};
